






















import Vue from 'vue';
import moment, { Moment } from 'moment';
import { debounce } from 'underscore';
import { ServiceAssignment } from '@/types';
import ServiceDayCard from '@/components/service/ServiceDayCard.vue';

moment.locale('nl');

export default Vue.extend({
  components: {
    ServiceDayCard,
  },

  computed: {
    date(): Moment {
      return moment(this.$store.getters['service/selectedDate']);
    },

    currentDate(): string {
      return this.date.calendar(undefined, {
        sameDay: '[Vandaag] - D MMMM YYYY',
        nextDay: '[Morgen] - D MMMM YYYY',
        nextWeek: 'dddd - D MMMM YYYY',
        lastDay: '[Gisteren] - D MMMM YYYY',
        lastWeek: 'dddd - D MMMM YYYY',
        sameElse: 'dddd - D MMMM YYYY',
      });
    },

    isFetching(): boolean {
      return this.$store.getters['service/isPending'];
    },

    assignments(): ServiceAssignment[] {
      // .slice() before .sort() keeps the computed side-effect-free (no in-place mutation).
      return this.$store.getters['service/byDate'](this.date.valueOf())
        .slice()
        .sort((a: ServiceAssignment, b: ServiceAssignment) =>
          (a.start_at ?? '').localeCompare(b.start_at ?? ''),
        );
    },
  },

  created() {
    this.$store.commit('service/setDate', Date.now());
    this.fetch();
  },

  methods: {
    nextDay() {
      this.date.add(1, 'day');
      this.$store.commit('service/setDate', this.date.valueOf());
    },

    previousDay() {
      this.date.subtract(1, 'day');
      this.$store.commit('service/setDate', this.date.valueOf());
    },

    fetch: debounce(function(this: Vue) {
      this.$store.dispatch('service/fetch:list');
    }, 500),
  },
});
